import { useFeatureValue } from '@shared/core/featureFlags';
import { ProductRow } from '../../PrimaryDashboardContent/PrimaryDashboardContent.types';
import { useGuestListRsvpProductRow } from './useGuestListRsvpProductRow';
import { useInvitationsProductRow } from './useInvitationsProductRow';
import { useRegistryProductRow } from './useRegistryProductRow';
import { useWebsiteProductRow } from './useWebsiteProductRow';
import { ProductVerticals } from '@shared/core/productVerticals/productVerticals.types';
import { EventPageType } from '@graphql/generated';

export type PageVisibility = 'hidden' | 'passwordProtected' | 'public';
export interface PageInfo {
  id: string;
  pageSlug: string;
  visibility: PageVisibility;
  type?: EventPageType;
  pageTitle?: string;
  createdAt?: {
    timestamp: string;
  };
  photo?: {
    id: string;
    url: string;
  } | null;
}
export function useProductRows(eventPages: ReadonlyArray<PageInfo>, productVerticals: ProductVerticals, eventId?: string, pendingRefundOrdersCount?: number) {
  const { value: messagingEnableHotelBlockReminder } = useFeatureValue('messagingEnableHotelBlockReminder');
  const { value: enableRsvpReminderMessage } = useFeatureValue('enableRsvpReminderMessage');
  const { value: printDayOfStationeryEnabled } = useFeatureValue('printDayOfStationeryEnabled');

  const websiteProductRow = useWebsiteProductRow(eventPages, productVerticals);
  const registryProductRow = useRegistryProductRow(eventPages, productVerticals, pendingRefundOrdersCount);
  const invitationsProductRow = useInvitationsProductRow({
    productVerticals,
    printThankYouCategoryEnabled: true,
    printDayOfStationeryEnabled: printDayOfStationeryEnabled === 'on',
    hotelBlockReminderEnabled: messagingEnableHotelBlockReminder === 'on',
    enableRsvpReminderMessage: enableRsvpReminderMessage === 'on',
    eventId,
  });
  const guestListRsvpProductRow = useGuestListRsvpProductRow(eventPages, productVerticals);

  const productRows: ProductRow[] = [websiteProductRow, registryProductRow, invitationsProductRow, guestListRsvpProductRow].sort((a, b) => {
    return (b.isEnabled ? 1 : 0) - (a.isEnabled ? 1 : 0);
  });

  return productRows;
}
